import { combineReducers } from 'redux'
import * as ActionTypes from '../../actions/actionTypes'

/** @reducer **/
const entities = (state = {}, action) => {
    switch (action.type) {
        case ActionTypes.OMNITEC_ORGANIZATIONS_FETCH_SUCCESS:
            return { ...state, organizations: action.data }
        case ActionTypes.OMNITEC_ORGANIZATIONS_SAVE_SUCCESS:
            return { ...state, organizations: [...state.organizations, action.data] }
        case ActionTypes.OMNITEC_ORGANIZATIONS_UPDATE_SUCCESS:
            return {
                ...state,
                organizations: [...state.organizations].map(item => {
                    if (item.ourId === action.data.ourId) {
                        return action.data
                    }
                    return item
                })
            }
        case ActionTypes.OMNITEC_ORGANIZATIONS_DELETE_SUCCESS:
            return {
                ...state,
                organizations: [...state.organizations].filter(item => item.ourId !== action.data)
            }
        default:
            return state
    }
}

/** @reducer **/
const result = (state = [], action) => {
    switch (action.type) {
        case ActionTypes.OMNITEC_ORGANIZATIONS_FETCH_SUCCESS:
            return [...action.data]
        case ActionTypes.OMNITEC_ORGANIZATIONS_SAVE_SUCCESS:
            return [...state, action.data]
        case ActionTypes.OMNITEC_ORGANIZATIONS_UPDATE_SUCCESS:
            return [...state].map(item => {
                if (item.ourId === action.data.ourId) {
                    return action.data
                }
                return item
            })

        case ActionTypes.OMNITEC_ORGANIZATIONS_DELETE_SUCCESS:
            return [...state].filter(item => item.ourId !== action.data)
        default:
            return state
    }
}

/** @reducer **/
const isFetching = (state = false, action) => {
    switch (action.type) {
        case ActionTypes.OMNITEC_ORGANIZATIONS_FETCH_REQUEST:
            return true
        case ActionTypes.OMNITEC_ORGANIZATIONS_FETCH_SUCCESS:
            return false
        case ActionTypes.OMNITEC_ORGANIZATIONS_FETCH_FAILURE:
            return false
        case ActionTypes.OMNITEC_ORGANIZATIONS_SAVE_SUCCESS:
            return false
        case ActionTypes.OMNITEC_ORGANIZATIONS_SAVE_FAILURE:
            return false
        case ActionTypes.OMNITEC_ORGANIZATIONS_UPDATE_SUCCESS:
            return false
        case ActionTypes.OMNITEC_ORGANIZATIONS_UPDATE_FAILURE:
            return false
        default:
            return state
    }
}

/** @reducer **/
const error = (state = null, action) => {
    switch (action.type) {
        case ActionTypes.OMNITEC_ORGANIZATIONS_FETCH_FAILURE:
            return action.data
        case ActionTypes.OMNITEC_ORGANIZATIONS_SAVE_FAILURE:
            return action.data
        case ActionTypes.OMNITEC_ORGANIZATIONS_UPDATE_FAILURE:
            return action.data
        default:
            return null
    }
}

export default combineReducers({ entities, isFetching, result, error })



// WEBPACK FOOTER //
// ./src/reducers/omnitecReducers/omnitecOrganizations.js